import React from 'react';
import { StepList, StepItem } from '../Guide.styles';

interface StepByStepProps {
  steps: string[];
}

export const StepByStep: React.FC<StepByStepProps> = ({ steps }) => (
  <StepList>
    {steps.map((step, index) => (
      <StepItem key={index}>{step}</StepItem>
    ))}
  </StepList>
);
